import React, { FunctionComponent, useRef, useContext } from 'react';
import type ReactLeaflet from 'react-leaflet';
import type Leaflet from 'leaflet';
import getStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import type { Marker } from 'react-leaflet';
import { MarkerData } from '../classes/MarkerData';

export interface NameMarkerProps {
  marker: MarkerData;
  nameSettings?: $TSFixMe;
}

export type NameMarkerPropsType = NameMarkerProps;

const NameMarker: FunctionComponent<NameMarkerPropsType> = (props: NameMarkerPropsType) => {
  const {
    marker,
    nameSettings = {
      'cmp-styles': {
        opacity: '0.5',
        'margin-left': '-20px'
      }
    },
    ...markerSettings
  } = props;
  const markerRef = useRef<Marker>(null);
  const { Marker } = require('react-leaflet') as typeof ReactLeaflet;
  const leaflet = require('leaflet') as typeof Leaflet;
  const { direction, theme } = useContext(Context);
  const [nameClassName] = getStyles(nameSettings, { direction, theme });

  const icon = leaflet.divIcon({
    className: 'custom-div-icon',
    html: `<div class="marker-name-container ${nameClassName}">${marker.name}</div>`,
    iconSize: [20, 20]
  });

  return (
    <Marker
      position={marker.location}
      ref={markerRef}
      icon={icon}
      keyboard={false}
      interactive={false}
      {...markerSettings}
    ></Marker>
  );
};

export default React.memo(NameMarker);
